export function formatStatInt(n: number): string {
  return new Intl.NumberFormat(undefined, { maximumFractionDigits: 0 }).format(
    n,
  );
}

export type DeltaVariant = "positive" | "negative" | "none";

/**
 * Percent change vs previous period. "Higher is better" for all dashboard metrics.
 */
export function formatPercentDelta(
  current: number,
  previous: number,
): { label: string; variant: DeltaVariant } {
  if (previous === 0) {
    if (current === 0) {
      return { label: "0%", variant: "none" };
    }
    return { label: "—", variant: "none" };
  }
  const p = ((current - previous) / previous) * 100;
  const rounded = Math.round(p * 10) / 10;
  const sign = rounded > 0 ? "+" : "";
  const label = `${sign}${rounded}%`;
  if (rounded > 0) {
    return { label, variant: "positive" };
  }
  if (rounded < 0) {
    return { label, variant: "negative" };
  }
  return { label: "0%", variant: "none" };
}
